import { render, staticRenderFns } from "./FlowRecordPanel.vue?vue&type=template&id=0e4bb314&"
import script from "./FlowRecordPanel.vue?vue&type=script&lang=js&"
export * from "./FlowRecordPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports